import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar-widget categories" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Nouvelles catégories", -1)
const _hoisted_4 = { class: "category-box" }
const _hoisted_5 = { class: "list-style" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "ri-login-box-line" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "produitTransfert" }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode(" Tarifs de nos moyens de transferts ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "produitColisPostaux" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Tarifs Colis postaux ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "produitEnvoisExpress" }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(" Tarifs Envois express ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "produitPosteLettre" }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(" Tarifs Poste aux lettres ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}